import React from 'react';
import './DashboardTaskbarBody.css';
import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import descriptionDetails from './DashboardDescription'

const DasboardTaskbarOthersBody = () => {
    return (
        <div className="dashboardtaskbarbody">
            {/* <DashboardTaskbarBodyTab header="Article Summary" body={descriptionDetails.Article_Summary} /> */}
            {/* <DashboardTaskbarBodyTab header="Pitch Yourself" body={descriptionDetails.Pitch_Yourself} /> */}
            {/* <DashboardTaskbarBodyTab header="Content Rewriter" body={descriptionDetails.Content_ReWriter} /> */}
            {/* <DashboardTaskbarBodyTab header="Short Sales Email" body={descriptionDetails.Short_Sales_Email} /> */}
        </div>
    )
}

export default DasboardTaskbarOthersBody;